import { render, staticRenderFns } from "./FigureManagement.vue?vue&type=template&id=00c1f1bd&scoped=true"
import script from "./FigureManagement.vue?vue&type=script&lang=js"
export * from "./FigureManagement.vue?vue&type=script&lang=js"
import style0 from "./FigureManagement.vue?vue&type=style&index=0&id=00c1f1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1f1bd",
  null
  
)

export default component.exports